export default __webpack_public_path__ + "static/media/COMPANY NAME LOCATED.f714fc56.mp3";